<div class="container section__preVerification h-full">
  <div class="wrapper">
    <form [formGroup]="form" (ngSubmit)="save()" class="form full__height">
      <div class="sectionContainer fadeinright animation-duration-300">
        <article>
          <div class="mainInfo">
            <h1>Verificación de identidad</h1>
            <p>
              Haz click en cada uno de los items del siguiente listado, para asegurarte que estás preparado para realizar la verificación.
            </p>
          </div>

          <div class="checkboxSelectionBox mt-25">
            <div class="checkboxSelectionBox__items">
              <div class="checkboxSelectionBox__item">
                <div class="form__group" [ngClass]="{'form__error': form.get('document_check')?.dirty && !form.get('document_check')?.valid}">
                  <label pRipple class="checkboxBox" for="dc">
                    <p-checkbox formControlName="document_check" value="document_check" inputId="dc"></p-checkbox>
                    <span class="checkboxBox__text">Tengo mi <strong>documento de indentidad</strong></span>
                  </label>
                </div>
              </div>

              <div class="checkboxSelectionBox__item">
                <div class="form__group" [ngClass]="{'form__error': form.get('illuminated_site_check')?.dirty && !form.get('illuminated_site_check')?.valid}">
                  <label pRipple class="checkboxBox" for="ns">
                    <p-checkbox formControlName="illuminated_site_check" value="illuminated_site_check" inputId="ns"></p-checkbox>
                    <span class="checkboxBox__text">Estoy en un <strong>sitio iluminado</strong></span>
                  </label>
                </div>
              </div>

              <div class="checkboxSelectionBox__item">
                <div class="form__group" [ngClass]="{'form__error': form.get('selfie_ready_check')?.dirty && !form.get('selfie_ready_check')?.valid}">
                  <label pRipple class="checkboxBox" for="ps">
                    <p-checkbox formControlName="selfie_ready_check" value="selfie_ready_check" inputId="ps"></p-checkbox>
                    <span class="checkboxBox__text">Estoy preparado para tomarme una <strong>selfie</strong></span>
                  </label>
                </div>
              </div>
            </div>
            <span class="form__msgError mt-15" *ngIf="form.get('document_check')?.dirty && !form.get('document_check')?.valid ||
            form.get('illuminated_site_check')?.dirty && !form.get('illuminated_site_check')?.valid || form.get('selfie_ready_check')?.dirty && !form.get('selfie_ready_check')?.valid ">
              <small class="p-error">Debe seleccionar todas las opciones</small>
            </span>
          </div>
        </article>

        <footer>
          <div class="footer__ref"><p>{{ 'Con este proceso autorizo consultar mis reportes de crédito.' | termReplace }}</p></div>
          <div class="footer__content">
            <button pButton pRipple type="submit" label="Comenzar la verificación" icon="pi pi-angle-right" iconPos="right" class="p-button-primary p-button-raised p-button-rounded w-full" [disabled]="this.form.invalid"></button>
          </div>
        </footer>
      </div>
    </form>
  </div>
</div>
